import Component from '../abstracts/Component';

export default class ListingHeadComponent extends Component {
  get SELECTORS() {
    return {
      fixedEl: '[data-listing-head-fixed]',
      header: '[data-js-component="HeaderComponent"]',
      listing: '.c-listing',
      //END WIP
      resultsCount: '.c-l-h__products-count'
    };
  }
  get CSS_CLASSNAMES() {
    return {
      menuOpen: 'menu-open',
    };
  }
  constructor(compEl) {
    super(compEl);
    this.height = this.$component.offsetHeight;
    this.header = document.querySelector(this.SELECTORS.header);
    this.fixedEl = this.$component.querySelector(this.SELECTORS.fixedEl);
    this.listing = document.querySelector(this.SELECTORS.listing);
    this.resultsCount = this.$component.querySelector(this.SELECTORS.resultsCount);
  }

  render() {
    super.render();
    this.bindEvents();
  }

  bindEvents() {
    this.$on(this.$customEvents.MENU_EVENTS.active, () => {
      this.$component.classList.add(this.CSS_CLASSNAMES.menuOpen);
    });
    this.$on(this.$customEvents.MENU_EVENTS.inactive, () => {
      this.$component.classList.remove(this.CSS_CLASSNAMES.menuOpen);
    });
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      let newCount = payload.response.querySelector('.c-l-h__products-count').innerHTML;
      if (this.resultsCount != null) {
        this.resultsCount.innerHTML = newCount;
      }
    });
    window.addEventListener('scroll', () => {
      if (
        this.$component.getBoundingClientRect().top < this.header.offsetHeight
      ) {
        this.fixedEl.style.position = 'fixed';
        if (this.listing) {
          this.listing.style.paddingTop = `${this.height}px`;
        }
      } else {
        this.fixedEl.style.position = '';
        if (this.listing) {
          this.listing.style.paddingTop = 0;
        }
      }
    });
  }
}
